import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appColumnResize]',
    standalone: false
})
export class ColumnResizeDirective implements OnInit {
  @Input('appColumnResize') resizable: boolean;

  @Input() columnIndex: number;

  private startX: number;

  private startWidth: number;

  private column: HTMLElement;

  private table: HTMLElement;

  private pressed: boolean;

  constructor(private renderer: Renderer2, private el: ElementRef) {
    //console.log('here');
    // renderer.setStyle(el.nativeElement, 'border-radius', '100px');
    // renderer.setStyle(el.nativeElement, 'background-color', 'red');
    this.column = this.el.nativeElement;
  }

  @HostListener('mouseenter') onMouseEnter(): void {
    //console.log('Enter');
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    //console.log('Leave');
  }

  ngOnInit(): void {
    if (this.resizable) {
      //console.log('column-resize attached.');

      const row = this.renderer.parentNode(this.column);
      const thead = this.renderer.parentNode(row);
      this.table = this.renderer.parentNode(thead);

      const resizer = this.renderer.createElement('span');
      this.renderer.addClass(resizer, 'resize-holder');
      this.renderer.appendChild(this.column, resizer);
      this.renderer.listen(resizer, 'mousedown', this.onMouseDown);
      this.renderer.listen(this.table, 'mousemove', this.onMouseMove);
      this.renderer.listen('document', 'mouseup', this.onMouseUp);
    }
  }

  onMouseDown = (event: MouseEvent) => {
    //console.log('on mouse down.');
    
    this.pressed = true;
    this.startX = event.pageX;
    this.startWidth = this.column.offsetWidth;
  }

  onMouseMove = (event: MouseEvent) => {
    //console.log('on mouse move');

    const offset = 35;
    if (this.pressed && event.buttons) {
      this.renderer.addClass(this.table, 'resizing');

      // Calculate width of column
      const width =
        this.startWidth + (event.pageX - this.startX - offset);

      const tableCells = Array.from(this.table.querySelectorAll('.mat-row')).map(
        (row: any) => row.querySelectorAll('.mat-cell').item(this.columnIndex)
      );

      // Set table header width
      this.renderer.setStyle(this.column, 'width', `${width}px`);
      //console.log(`set table header width to: ${width}`);

      // Set table cells width
      for (const cell of tableCells) {
        //console.log(`set table cell width to: ${width}`);
        this.renderer.setStyle(cell, 'width', `${width}px`);
      }
    }
  }

  onMouseUp = (event: MouseEvent) => {
    if (this.pressed) {
      this.pressed = false;
      this.renderer.removeClass(this.table, 'resizing');
    }
  }
}

